import Common from '../common';

const Measure = {
  /**
   * Google Maps Platform
   */
  google        : null,
  /**
   * 地図
   */
  map           : null,
  /**
   * Vue Map Google
   */
  vueMapGoogle  : null,
  /**
   * Display map in measure mode or not
   */
  mode          : false,
  /**
   * Icon
   */
  icon          : null,
  /**
   * Markers
   */
  markers       : [],
  /**
   * Polygon
   */
  polygon       : null,
  /**
   * Polygon options
   */
  polygonOptions: {
    strokeColor  : '#F6BABA',
    strokeOpacity: 0.8,
    strokeWeight : 2,
    fillColor    : '#F6BABA',
    fillOpacity  : 0.2,
  },
  /**
   * 初期化
   *
   * @param mapModule
   * @param google
   * @param map
   * @param vueMapGoogle
   */
  init(mapModule, google, map, vueMapGoogle) {
    const self = this;
    return new Promise((resolve) => {
      self.mapModule    = mapModule;
      self.google       = google;
      self.map          = map;
      self.vueMapGoogle = vueMapGoogle;
      self.polygon      = new self.google.maps.Polygon(self.polygonOptions);
      self.polygon.setMap(self.map);
      self.polygon.addListener('click', function (event) {
        self.setMarker(event.latLng, self.vueMapGoogle);
      });
      self.clearMarkers();
      self.setMode(false);
      self.generateIcon();
      return resolve();
    });
  },
  /**
   * Set in measure mode
   *
   * @param mode
   */
  setMode(mode) {
    this.mode = mode;
    return this;
  },
  /**
   * Get in measure mode
   *
   * @returns {boolean}
   */
  getMode() {
    return this.mode;
  },
  /**
   * マーカー用のアイコンを生成
   */
  generateIcon() {
    this.icon = {
      path       : this.google.maps.SymbolPath.CIRCLE,
      strokeColor: '#EE675C',
      fillColor  : '#F6BABA',
      fillOpacity: 1,
      scale      : 5,
    };
  },
  /**
   * 距離・面積を測定
   *
   * @param vueMapGoogle
   */
  measure(vueMapGoogle) {
    const path = this.markers.map(marker => marker.getPosition());
    if (!this.polygon) {
      return;
    }
    this.polygon.setPath(path)

    // 3点以上指定されている場合は、閉鎖された空間として面積の計算が行えるため、
    // 始点を末尾に追加して閉鎖空間と処理する
    if (path.length >= 3) {
      path.push(path[0]);
    }

    const distance       = this.google.maps.geometry.spherical.computeLength(
      path
    );
    const area           = this.google.maps.geometry.spherical.computeArea(
      path
    );
    const distanceResult = distance ? '距離：' + Common.numberFormat(distance, 1) + 'm' : '';
    const areaResult     = area ? '、面積：' + Common.numberFormat(area, 1) + 'm²' : '';
    const result         = distanceResult + areaResult;
    vueMapGoogle.$emit('displayMeasureResult', result);
  },
  /**
   * Remove a measure marker
   *
   * @param marker
   * @param vueMapGoogle
   */
  removeMeasureMarker(marker, vueMapGoogle) {
    marker.setMap(null);
    const index = this.markers.indexOf(marker);
    this.markers.splice(index, 1);
    this.measure(vueMapGoogle);
  },
  /**
   * Remove all measure markers
   */
  clearMarkers() {
    if (this.polygon) {
      this.polygon.setPath([]);
    }
    this.markers.map(maker => maker.setMap(null));
    this.markers.splice(0, this.markers.length);
  },
  /**
   * メジャー用のマーカーを生成
   *
   * @param position
   * @param vueMapGoogle
   */
  setMarker(position, vueMapGoogle) {
    const self = this;
    if (this.mapModule && this.mapModule.getIsLongPress()) {
      return;
    }
    if (!this.getMode()) {
      return
    }

    const marker = new this.google.maps.Marker({
      map      : this.map,
      draggable: true,
      position : position,
      icon     : this.icon,
      title    : Common.messages.measureMarkerTitle,
    });
    marker.addListener('click', function () {
      self.removeMeasureMarker(marker, vueMapGoogle);
    });
    marker.addListener('position_changed', function () {
      self.measure(vueMapGoogle);
    });
    this.markers.push(marker);
    this.measure(vueMapGoogle);
  },
}

export default Measure;